import CustomerActions, { customerActionTypes } from '@Actions/customerActions';
import {
  put, takeLatest, all,
} from 'redux-saga/effects';
import TrackerActions from '@Actions/trackerActions';
import CustomerService from '@Services/customerServices';
import { notification } from 'antd';

/**
 * @param action
 */
function* _createCustomer(action) {
  try {
    yield put(CustomerActions.createCustomerLoading(true));
    const { payload } = action;
    const customer = yield CustomerService.createCustomer(payload);
    if (!customer.success) {
      yield put(TrackerActions.trackAction(customerActionTypes.CREATE_CUSTOMER.SUCCESS, customer.data));
      notification.open({
        type: 'error',
        message: customer?.message,
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'success',
        message: 'Customer added',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback(customer.customer);
      }
    }
    yield put(CustomerActions.createCustomerLoading(false));
  } catch (error) {
    yield put(CustomerActions.createCustomerLoading(false));
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(customerActionTypes.CREATE_CUSTOMER.ERROR, error));
  }
}

/**
 *
 */
function* createCustomer() {
  yield takeLatest(customerActionTypes.CREATE_CUSTOMER.REQUEST, _createCustomer);
}

/**
 * @param action
 */
function* _getCustomerById(action) {
  try {
    yield put(CustomerActions.getCustomerByIdLoading(true));
    const selectedCustomer = yield CustomerService.getCustomerById(action.customerId, action.tenantId);
    yield put(CustomerActions.getCustomerByIdSuccess(selectedCustomer?.customers?.[0]));
    yield put(CustomerActions.getCustomerByIdLoading(false));
  } catch (error) {
    yield put(CustomerActions.getCustomerByIdLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(customerActionTypes.GET_CUSTOMER_BY_ID.ERROR, error));
  }
}

/**
 *
 */
function* getCustomerById() {
  yield takeLatest(customerActionTypes.GET_CUSTOMER_BY_ID.REQUEST, _getCustomerById);
}

/**
 * @param action
 */
function* _getCustomers(action) {
  try {
    yield put(CustomerActions.getCustomersLoading(true));
    const customers = yield CustomerService.getCustomers(action.keyword, action.tenantId, action.page, action?.limit, action?.customerId, action?.accountManagerIds, action.selectedCustomerIds, action.excludeCustomerIds, action?.advanceFilters);
    yield put(CustomerActions.getCustomersSuccess(customers));
    yield put(CustomerActions.getCustomersLoading(false));
    if (action.callback) {
      action.callback(customers);
    }
  } catch (error) {
    yield put(CustomerActions.getCustomersLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(customerActionTypes.GET_CUSTOMERS.ERROR, error));
  }
}

/**
 *
 */
function* getCustomers() {
  yield takeLatest(customerActionTypes.GET_CUSTOMERS.REQUEST, _getCustomers);
}

/**
 * @param action
 */
function* _updateCustomer(action) {
  try {
    yield put(CustomerActions.updateCustomerLoading(true));
    const { payload } = action;
    const updatedCustomer = yield CustomerService.updateCustomer(payload);
    if (!updatedCustomer.success) {
      notification.open({
        type: 'error',
        message: updatedCustomer.message,
        duration: 4,
        placement: 'top',
      });
    } else {
      yield put(TrackerActions.trackAction(customerActionTypes.UPDATE_CUSTOMER.SUCCESS, updatedCustomer.data));
      notification.open({
        type: 'success',
        message: 'Customer update successful.',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
    }
    yield put(CustomerActions.updateCustomerLoading(false));
  } catch (error) {
    yield put(CustomerActions.updateCustomerLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(customerActionTypes.UPDATE_CUSTOMER.ERROR, error));
  }
}

/**
 *
 */
function* updateCustomer() {
  yield takeLatest(customerActionTypes.UPDATE_CUSTOMER.REQUEST, _updateCustomer);
}

function* _getOrgCustomers(action) {
  try {
    yield put(CustomerActions.getOrgCustomersLoading(true));
    const orgCustomers = yield CustomerService.getOrgCustomers(action.keyword, action.page, action?.limit, action?.isArchiveCustomer);
    yield put(CustomerActions.getOrgCustomersSuccess(orgCustomers));
    yield put(CustomerActions.getOrgCustomersLoading(false));
    if (action.callback) {
      action.callback(orgCustomers);
    }
  } catch (error) {
    yield put(CustomerActions.getOrgCustomersLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(customerActionTypes.GET_ORG_CUSTOMERS.ERROR, error));
  }
}

/**
 *
 */
function* getOrgCustomers() {
  yield takeLatest(customerActionTypes.GET_ORG_CUSTOMERS.REQUEST, _getOrgCustomers);
}

/**
 *
 * @returns {Generator<Promise<*>|*, void, *>}
 * @private
 */
function* _getBulkUploadCustomerMetadata() {
  try {
    yield put(CustomerActions.getBulkUploadCustomerMetadataLoading(true));
    yield put(CustomerActions.bulkUploadCustomersError(null));
    const bulkUploadMetaData = yield CustomerService.getBulkUploadCustomerMetadata();
    if (bulkUploadMetaData.success) {
      yield put(CustomerActions.getBulkUploadCustomerMetadataSuccess(bulkUploadMetaData));
    } else {
      notification.open({
        type: 'error',
        message: 'Something went wrong while initiating your request',
        duration: 4,
        placement: 'top',
      });
    }
    yield put(CustomerActions.getBulkUploadCustomerMetadataLoading(false));
  } catch (error) {
    yield put(CustomerActions.getBulkUploadCustomerMetadataLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
  }
}
/**
 *
 * @returns {Generator<*, void, *>}
 */
function* getBulkUploadCustomerMetadata() {
  yield takeLatest(customerActionTypes.GET_BULK_UPLOAD_CUSTOMER_META_DATA.REQUEST, _getBulkUploadCustomerMetadata);
}

function* _bulkUploadCustomers(action) {
  try {
    yield put(CustomerActions.bulkUploadCustomersLoading(true));
    yield put(CustomerActions.bulkUploadCustomersError(null));
    const { payload } = action;
    const bulkUpload = yield CustomerService.bulkUploadCustomers(payload);
    if (bulkUpload.success) {
      notification.open({
        type: 'success',
        message: 'We are processing your request. Please check the status on bulk imports section.',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
    } else {
      yield put(CustomerActions.bulkUploadCustomersError(bulkUpload.error));
    }
    yield put(CustomerActions.bulkUploadCustomersLoading(false));
  } catch (error) {
    yield put(CustomerActions.bulkUploadCustomersLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
  }
}
function* bulkUploadCustomers() {
  yield takeLatest(customerActionTypes.BULK_UPLOAD_CUSTOMER.REQUEST, _bulkUploadCustomers);
}

function* _bulkUpdateCustomers(action) {
  try {
    yield put(CustomerActions.bulkUpdateCustomersLoading(true));
    yield put(CustomerActions.bulkUpdateCustomersError(null));
    const { payload } = action;
    const bulkUpdate = yield CustomerService.bulkUpdateCustomers(payload);
    if (bulkUpdate.success) {
      notification.open({
        type: 'success',
        message: 'We are processing your request. Please check the status on bulk imports section.',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
    } else {
      yield put(CustomerActions.bulkUpdateCustomersError(bulkUpdate.error));
      notification.open({
        type: 'error',
        message: bulkUpdate.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(CustomerActions.bulkUpdateCustomersLoading(false));
  } catch (error) {
    yield put(CustomerActions.bulkUpdateCustomersLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
  }
}

function* bulkUpdateCustomers() {
  yield takeLatest(customerActionTypes.BULK_UPDATE_CUSTOMER.REQUEST, _bulkUpdateCustomers);
}

function* _getTallyCustomers(action) {
  try {
    yield put(CustomerActions.getTallyCustomersSuccess(null));
    yield put(CustomerActions.getTallyCustomersLoading(true));
    const {
      itId, orgId, searchKeyword, callback, selectedCustomer
    } = action;
    const tallyCustomers = yield CustomerService.getTallyCustomers(itId, orgId, searchKeyword, selectedCustomer);
    if (callback) {
      action.callback();
    }
    yield put(CustomerActions.getTallyCustomersSuccess(tallyCustomers));
    yield put(CustomerActions.getTallyCustomersLoading(false));
  } catch (error) {
    yield put(CustomerActions.getTallyCustomersLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(customerActionTypes.GET_TALLY_CUSTOMERS.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* getTallyCustomers() {
  yield takeLatest(customerActionTypes.GET_TALLY_CUSTOMERS.REQUEST, _getTallyCustomers);
}

/**
 *
 */
export default function* customerSaga() {
  yield all([createCustomer(), getCustomerById(), getCustomers(), updateCustomer(), getOrgCustomers(), getBulkUploadCustomerMetadata(), bulkUploadCustomers(), bulkUpdateCustomers(), getTallyCustomers()]);
}
